import { render, staticRenderFns } from "./MenuOptionList.vue?vue&type=template&id=71456a1c"
import script from "./MenuOptionList.vue?vue&type=script&lang=js"
export * from "./MenuOptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports